<template>
  <el-drawer
    ref="drawerRef"
    :visible.sync="visible"
    direction="rtl"
    :with-header="false"
    v-bind="$attrs"
    custom-class="basic_drawer_wrapper"
    v-on="$listeners"
  >
    <header class="drawer_header">
      <h3 class="title">{{ title }}</h3>
      <span class="el-icon-close close_icon pointer" @click="closeDrawer"></span>
    </header>

    <section class="drawer__body">
      <slot></slot>
    </section>

    <slot name="footer" class="drawer__footer">
      <div class="drawer__footer">
        <el-button @click="cancel">取 消</el-button>
        <slot name="confirmButton">
          <el-button type="primary" @click="confirm">确 认</el-button>
        </slot>
      </div>
    </slot>
  </el-drawer>
</template>

<script>
export default {
  name: 'BasicDrawer',

  inheritAttrs: true,

  props: {
    title: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      visible: false,
    }
  },

  methods: {
    open() {
      this.visible = true
    },

    close() {
      this.$refs.drawerRef.closeDrawer()
    },

    closeDrawer() {
      this.$refs.drawerRef.closeDrawer()
    },

    confirm() {
      this.$emit('confirm')
    },

    cancel() {
      this.$emit('cancel')
      this.closeDrawer()
    },
  },
}
</script>

<style lang="scss">
// ::v-deep {
.basic_drawer_wrapper {
  background-color: #fefefe;
  border-radius: 4px 0 0 4px;

  .title {
    color: var(--dark30);
  }

  .close_icon {
    color: var(--grey66);
    font-size: 20px;
    font-weight: 700;
  }

  .el-drawer__body {
    display: flex;
    flex-direction: column;
  }
}
// }

.drawer_header,
.drawer__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding-left: 24px;
  padding-right: 24px;
}

.drawer_header {
  border-bottom: 1px solid #ececec;
}

.drawer__footer {
  justify-content: flex-end;
  border-top: 1px solid #ececec;

  .el-button + .el-button {
    margin-left: 20px;
  }
}

.drawer__body {
  flex: 1;
  padding: 25px 34px 20px;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
}
</style>
